import { Instance, types } from 'mobx-state-tree';

export const LibraryInformationModel = types.model('LibraryInformationModel', {
    tag: types.string,
    title: types.string,
    description: types.maybeNull(types.string),
    price: types.string,
    term: types.string,
    purchaseType: types.string,
    purchaseLink: types.string,
    images: types.array(types.string),
});

export type TypeLibraryInformationModel = Instance<typeof LibraryInformationModel>;

export default LibraryInformationModel;
